import React from "react";
import { Button, Dropdown, Menu } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import "./CardMenuButton.less";

const CardMenuButton = ({ items = [], onMenuClick, className = "" }) => {
    const handleMenuClick = ({ key, domEvent }) => {
        domEvent.preventDefault();
        domEvent.stopPropagation();
        if (onMenuClick) {
            onMenuClick(key);
        }
    };

    return (
        <div className={`card-menu-button-v2 ${className}`.trim()}>
            <Dropdown
                overlay={
                    <Menu
                        onClick={handleMenuClick}
                        items={items}
                    />
                }
                trigger={["click"]}>
                <Button
                    type="text"
                    className="card-menu-button-v2__icon-btn"
                    icon={<MenuOutlined />}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                />
            </Dropdown>
        </div>
    );
};

export default CardMenuButton;
